// Core
import React from 'react';

// Charts
import {
    CartesianGrid,
    Legend,
    Line as RechartsLine,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

// Theme
import { CHART_COLORS } from '../theme';

const CHART_MARGIN = { top: 8, right: 16, bottom: 8, left: 8 };

const DEFAULT_TOOLTIP_PROPS = {
    cursor: { fill: CHART_COLORS.tooltipCursor },
    contentStyle: {
        backgroundColor: CHART_COLORS.tooltipBackground,
        borderColor: CHART_COLORS.tooltipBackground,
        borderRadius: '4px',
        color: CHART_COLORS.tooltipText,
        padding: '8px',
    },
};

const DEFAULT_LEGEND_PROPS = {
    align: 'center',
    layout: 'horizontal',
    verticalAlign: 'top',
};

export const ChartLegend = ({ payload = [], verticalAlign = 'top' }) => (
    <ul className={`statCard-legend statCard-legend--${verticalAlign}`}>
        {payload.map((entry) => (
            <li key={entry.value} style={{ color: CHART_COLORS.text }}>
                <span style={{ color: entry.color }}>●</span> {entry.value}
            </li>
        ))}
    </ul>
);

const Line = ({ data = [], chartProps = {} }) => {
    const {
        series = [],
        xAxis = {},
        yAxis = {},
        tooltipProps = DEFAULT_TOOLTIP_PROPS,
        legendProps = DEFAULT_LEGEND_PROPS,
    } = chartProps;

    return (
        <div className="statCard-chart">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data} margin={CHART_MARGIN}>
                <CartesianGrid
                    horizontal={false}
                    stroke={CHART_COLORS.axis}
                    strokeDasharray="3 3"
                />
                <XAxis {...xAxis} stroke={CHART_COLORS.axis} tickMargin={2} />
                <YAxis
                    allowDecimals={false}
                    {...yAxis}
                    stroke={CHART_COLORS.axis}
                    tick={{ fill: CHART_COLORS.text, fontSize: '12px' }}
                    tickMargin={4}
                />
                <Tooltip {...tooltipProps} />
                {legendProps === false ? null : (
                    <Legend content={<ChartLegend />} {...legendProps} />
                )}
                {series.map(({ dataKey, ...rest }) => (
                    <RechartsLine
                        key={dataKey}
                        dataKey={dataKey}
                        type="monotone"
                        dot={data.length < 2}
                        {...rest}
                    />
                ))}
            </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Line;
